module.exports = __webpack_public_path__ + "img/ios-icon-step2.62bed75b.png";